// extracted by mini-css-extract-plugin
export default {"moreInfoText":"GiftBottomSection_moreInfoText__fMxjF","linkText":"GiftBottomSection_linkText__Wd1WX"};